import { useState } from 'react';
import Gap from '~/components/Gap';
import Pill from '~/components/Pill';
import { IListInvoice } from '~/types/invoice';
import AddClientModal from '../../Client/AddClient/AddClientModal';
import SendInvoiceModal from '../SendInvoiceModal';
import TextButton from '~/components/TextButton';
import Portal from '~/components/Portal';
import { useInvoiceListContext } from '../hooks/useInvoiceListContext';

interface IInvoiceStatusPillsProps {
  invoiceData: IListInvoice;
  showActions?: boolean;
}

const InvoiceStatusPills = ({ invoiceData, showActions = false }: IInvoiceStatusPillsProps) => {
  const { onEditListInvoice } = useInvoiceListContext();
  const [isClientModalOpen, setIsClientModalOpen] = useState(false);
  const [isSendModalOpen, setIsSendModalOpen] = useState(false);

  function handleCloseClientModal() {
    setIsClientModalOpen(false);
  }

  function handleOpenClientModal() {
    setIsClientModalOpen(true);
  }

  function handleCloseSendModal() {
    setIsSendModalOpen(false);
  }

  function handleOpenSendModal() {
    setIsSendModalOpen(true);
  }

  if (invoiceData.archived === true) {
    return (
      <div className="align-center full-width">
        <Pill variant="danger">Archived</Pill>
      </div>
    );
  }

  let dueColor: 'danger' | 'primary' | 'success' = 'danger';
  if (invoiceData.payment_due_status === 'Overdue') {
    dueColor = 'danger';
  } else if (invoiceData.payment_due_status === 'On Time') {
    dueColor = 'primary';
  } else {
    dueColor = 'success';
  }

  return (
    <>
      {showActions && (
        <Portal>
          <AddClientModal
            isModalOpen={isClientModalOpen}
            onCloseClientModal={handleCloseClientModal}
            heading="Edit Client"
            clientId={invoiceData.client_uuid}
          />
          <SendInvoiceModal
            isModalOpen={isSendModalOpen}
            onCloseModal={handleCloseSendModal}
            invoiceUuid={invoiceData.invoice_uuid}
            onOpenClientModal={handleOpenClientModal}
            successCallback={() => {
              onEditListInvoice(invoiceData.invoice_uuid, { status: 'Sent' });
            }}
          />
        </Portal>
      )}

      <div>
        <div className="align-center">
          <Pill variant={invoiceData.status === 'Sent' ? 'primary' : 'secondary'}>
            {invoiceData.status}
          </Pill>
          <Gap r={8} />
          <Pill variant={dueColor}>{invoiceData.payment_due_status}</Pill>
        </div>
        {showActions && invoiceData.status === 'Draft' && invoiceData.archived === false && (
          <>
            <Gap t={4} />
            <TextButton variant="secondary" size="sm" underline onClick={handleOpenSendModal}>
              Email now
            </TextButton>
          </>
        )}
      </div>
    </>
  );
};

export default InvoiceStatusPills;
